import { render, staticRenderFns } from "./IterationGlobal.vue?vue&type=template&id=0f61410f"
import script from "./IterationGlobal.vue?vue&type=script&lang=js"
export * from "./IterationGlobal.vue?vue&type=script&lang=js"
import style0 from "./IterationGlobal.vue?vue&type=style&index=0&id=0f61410f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports